import { getFunctions, httpsCallable } from "firebase/functions";
import useSWR from "swr";
import { firebaseApp } from "../../../firebase/firebaseClient";
import {
  IncomingPrepFqAnalyticsQuery,
  PrepFqAnalyticsItem,
  QueryInterval,
} from "../../../models/prepFqQuiz";
import logger from "../../../utils/logger";

const fetcher = async (url: string) => {
  if (url) {
    try {
      const functions = getFunctions(firebaseApp);
      const onFetchPrepFqAnalytics = httpsCallable(
        functions,
        "onFetchPrepFqAnalytics"
      );

      const splits = url.split("/");
      const start_date = parseFloat(splits[5]);
      const end_date = parseFloat(splits[6]);
      const interval = splits[7];
      const analyticsSnap = await onFetchPrepFqAnalytics({
        start_date,
        end_date,
        interval,
      } as IncomingPrepFqAnalyticsQuery);
      return (analyticsSnap.data as any).items;
    } catch (error) {
      await logger.e(error);
      return undefined;
    }
  } else {
    return undefined;
  }
};

function usePrepFqAnalytics(
  user_id: string,
  start_date: number,
  end_date: number,
  interval: QueryInterval
) {
  const { data, mutate, isValidating, error } = useSWR(
    [
      user_id
        ? `users/${user_id}/analytics/prep_fq/dailies/${start_date}/${end_date}/${interval}`
        : null,
    ],
    fetcher
  );
  const result: {
    analyticsItems: PrepFqAnalyticsItem[];
    isLoading: boolean;
    isValidating: boolean;
    isError: boolean;
    mutate: any;
  } = {
    analyticsItems: data as any,
    isLoading: !error && !data,
    isValidating,
    isError: error,
    mutate,
  };
  return result;
}

export default usePrepFqAnalytics;
